import React, { useState } from "react";
import { Form, Formik } from "formik";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const Wizard = ({ children, initialValues, onSubmit }) => {
  const classes = useStyles();
  const [stepNumber, setStepNumber] = useState(0);
  const steps = React.Children.toArray(children);
  const [snapshot, setSnapshot] = useState(initialValues);

  const step = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;

  const next = (values) => {
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };

  const previous = (values) => {
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };

  const handleSubmit = async (values, bag) => {
    if (step.props.onSubmit) {
      await step.props.onSubmit(values, bag);
    }
    if (isLastStep) {
      return onSubmit(values, bag);
    } else {
      bag.setTouched({});
      next(values);
    }
  };

  return (
    <Formik
      initialValues={snapshot}
      onSubmit={handleSubmit}
      validationSchema={step.props.validationSchema}
    >
      {(formik) => (
        <Form>
          {/* <p>
            Step {stepNumber + 1} of {totalSteps}
          </p> */}
          {step}
          <div className="d-flex stepfrmbtns">
            <div className="col-6 p-0">
              {stepNumber > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  className="m-0 px-5 bg-default-red py-2"
                  onClick={() => previous(formik.values)}
                  type="button"
                >
                  Back
                </Button>
              )}
            </div>
            <div className="col-6 p-0 d-flex justify-content-end">
              {stepNumber !== 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  className="m-0 px-5 bg-default-blue py-2"
                  disabled={formik.isSubmitting}
                  type="submit"
                >
                  {isLastStep ? "Submit" : "Next"}
                </Button>
              )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Wizard;